import { isRadius as $isRadius } from '../../../../models/application-types';
import {
    mobileApplicationSettingsFromDto,
    mobileApplicationSettingsToDto
} from '../mobile-app-support/mobile-app-support.functions';

export function loginServicesConfigurationModelFromDto(dto) {
    const slug = dto.applicationType.slug;
    const isCas = slug === 'cas';
    const isComputerLoginWithAD = slug === 'computer-login';
    const isComputerLoginWithoutAD = slug === 'computer-protection-without-ad';
    const isComputerLogin = isComputerLoginWithAD || isComputerLoginWithoutAD;
    const isCustom = slug === 'custom';
    const isTsPlus = slug === 't-splus';
    const isSRA = slug === 'saaspass-secure-remote-access';
    const isEPM = slug === 'enterprise-password-manager';
    const isAdPM = slug === 'ad-password-manager';
    const isExchangeActiveSync = slug === 'exchange-active-sync';
    const isLinuxSsh = slug === 'linux-ssh';
    const isRadius = $isRadius(slug);
    const isSaml = dto.applicationType.saml;
    const isOidcConfigSupported = dto.applicationType.oidcConfigSupported;
    const isInstantLoginEditable = isCustom || isComputerLogin || isSaml || isOidcConfigSupported;
    const isInstantLoginMethodsSectionVisible = dto.applicationType.instantLoginSupported || dto.applicationType.proximitySupported || dto.applicationType.pushLoginSupported;
    const isInstantLoginUrlVisible = isInstantLoginMethodsSectionVisible && (isCas || !isComputerLogin && !isLinuxSsh && !isRadius && !isSaml && !isExchangeActiveSync && !isOidcConfigSupported);
    const isIpFilteringVisible = ['cas', 'custom', 'linux-ssh', 'owa', 't-splus', 'thinfinity','magento','exchange-active-sync'].includes(slug);
    const isProximityEditable = dto.applicationType.proximitySupported && (isComputerLogin || isCustom || isSaml);
    const isPushLoginEditable = dto.applicationType.pushLoginSupported && (isComputerLogin || isCustom || isLinuxSsh || isRadius || isTsPlus || isSRA || isSaml || isOidcConfigSupported);

    return {
        instantLoginEnabled: dto.instantLoginEnabled,
        instantLoginSupported: dto.applicationType.instantLoginSupported,
        instantLoginUrl: dto.instantLoginUrl,
        ipAddressFilter: dto.ipAddressFilter || '0.0.0.0/0',
        isComputerLogin,
        isCustom,
        isEditable: dto.applicationType.ssoEditable || dto.applicationType.ssoPostUrlEditable || isComputerLogin || isInstantLoginUrlVisible || isIpFilteringVisible || isRadius || isProximityEditable || isPushLoginEditable || isInstantLoginEditable,
        isInstantLoginEditable,
        isInstantLoginMethodsSectionVisible,
        isInstantLoginUrlVisible,
        isIpFilteringVisible,
        isProximityEditable,
        isPushLoginEditable,
        isVisible: !(isEPM || isAdPM),
        isRunning: dto.status === 'RUNNING',
        mobileApplicationSettings: mobileApplicationSettingsFromDto(dto.mobileApplicationSettings),
        noIpAddressFilter: !dto.ipAddressFilter || dto.ipAddressFilter === '0.0.0.0/0',
        proximityEnabled: dto.proximityEnabled,
        proximitySupported: dto.applicationType.proximitySupported,
        pushLoginEnabled: dto.pushLoginEnabled,
        pushLoginSupported: dto.applicationType.pushLoginSupported,
        qrCodeBackgroundColor: (dto.ilQrCodeSettings || {}).qrCodeBackgroundColor || '#FFFFFF',
        qrCodeForegroundColor: (dto.ilQrCodeSettings || {}).qrCodeForegroundColor || '#000000',
        qrCodeSize: (dto.ilQrCodeSettings || {}).qrCodeSize || 300,
        rememberMeEnabled: dto.rememberMeEnabled,
        autoLoginEnabled: dto.autoLoginEnabled,
        remoteLockEnabled: dto.remoteLockEnabled,
        remoteLoginEnabled: dto.remoteLoginEnabled,
        ssoEditable: dto.applicationType.ssoEditable,
        ssoPostUrlEditable: dto.applicationType.ssoPostUrlEditable,
        ssoEnabled: dto.ssoEnabled,
        ssoPostUrl: dto.ssoEnabled && dto.ssoPostUrl || '',
        ssoSupported: dto.applicationType.ssoSupported,
        upgradeNotificationEnabled: dto.upgradeNotificationEnabled,
        isOidcConfigSupported,
    };
}

export function loginServicesConfigurationModelToDto(model) {
    return {
        instantLoginEnabled: model.instantLoginEnabled,
        instantLoginUrl: model.instantLoginUrl,
        mobileApplicationSettings: mobileApplicationSettingsToDto(model.mobileApplicationSettings),
        ipAddressFilter: model.noIpAddressFilter || !model.ipAddressFilter ? '0.0.0.0/0' : model.ipAddressFilter,
        proximityEnabled: model.proximityEnabled,
        pushLoginEnabled: model.pushLoginEnabled,
        ilQrCodeSettings: {
            qrCodeBackgroundColor: model.qrCodeBackgroundColor,
            qrCodeForegroundColor: model.qrCodeForegroundColor,
            qrCodeSize: model.qrCodeSize,
            qrCodeType: 'IL',
        },
        rememberMeEnabled: model.rememberMeEnabled,
        autoLoginEnabled: model.autoLoginEnabled,
        remoteLockEnabled: model.remoteLockEnabled,
        remoteLoginEnabled: model.remoteLoginEnabled,
        ssoEnabled: model.ssoEnabled,
        ssoPostUrl: model.ssoEnabled && model.ssoPostUrl || undefined,
        upgradeNotificationEnabled: model.upgradeNotificationEnabled,
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/configuration/login-services-form.functions.js